import { render, staticRenderFns } from "./RelativeVisit.vue?vue&type=template&id=009b0741&scoped=true"
import script from "./RelativeVisit.vue?vue&type=script&lang=js"
export * from "./RelativeVisit.vue?vue&type=script&lang=js"
import style0 from "./RelativeVisit.vue?vue&type=style&index=0&id=009b0741&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "009b0741",
  null
  
)

export default component.exports